import React, { useState } from 'react';
import { Box, Button, Stack, TextField, Typography } from '@mui/material';
import axiosInstance from '../services';

const ResolveEventId = () => {
  const [text, setText] = useState('');
  const [anchorDate, setAnchorDate] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!text.trim()) {
      setError('Text is required');
      return;
    }

    setError('');
    setResult(null);
    setLoading(true);

    try {
      const payload = { text: text.trim() };
      if (anchorDate) {
        payload.anchor_date = anchorDate;
      }

      const response = await axiosInstance.post('/meta/resolve_event_id/', payload);
      setResult(response.data);
    } catch (err) {
      const message = err.response?.data?.message || err.message || 'Failed to resolve event ID';
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 640, margin: '0 auto', padding: 3 }}>
      <Typography variant="h5" gutterBottom>
        Resolve Event ID
      </Typography>

      <Box component="form" onSubmit={handleSubmit} noValidate>
        <Stack spacing={2}>
          <TextField
            label="Input Text"
            value={text}
            onChange={(event) => setText(event.target.value)}
            required
            multiline
            minRows={2}
            helperText="Enter the string you want to resolve"
            disabled={loading}
          />

          <TextField
            label="Anchor Date"
            type="date"
            value={anchorDate}
            onChange={(event) => setAnchorDate(event.target.value)}
            InputLabelProps={{ shrink: true }}
            helperText="Optional, format YYYY-MM-DD"
            disabled={loading}
          />

          <Button type="submit" variant="contained" disabled={loading || !text.trim()}>
            {loading ? 'Resolving…' : 'Resolve'}
          </Button>
        </Stack>
      </Box>

      {error && (
        <Typography color="error" sx={{ mt: 2 }}>
          {error}
        </Typography>
      )}

      {result && (
        <Box sx={{ mt: 3 }}>
          <Typography variant="subtitle1" gutterBottom>
            Resolved: {result.resolved ? 'Yes' : 'No'}
          </Typography>
          <Typography variant="subtitle1" gutterBottom>
            Event ID: {result.event_id || '—'}
          </Typography>
          <Typography variant="subtitle1" gutterBottom>
            Source: {result.source || '—'}
          </Typography>
          <Typography variant="body2" sx={{ mt: 2 }}>
            Raw response
          </Typography>
          <Box
            component="pre"
            sx={{
              mt: 1,
              p: 2,
              borderRadius: 1,
              backgroundColor: '#f5f5f5',
              maxHeight: 320,
              overflow: 'auto',
              fontFamily: 'Menlo, Consolas, monospace',
              fontSize: 14,
            }}
          >
            {JSON.stringify(result, null, 2)}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default ResolveEventId;
